/* verqo — Route dispatchers for the nav preview
   Reads slug from URL params, looks up content, renders SubPageRenderer.
   All routes fall back to a friendly "not found" state.
*/
import { useParams, Link } from "react-router-dom";
import SubPageRenderer from "./SubPageRenderer";
import { SubPageLayout, Eyebrow } from "../../../components/marketing/SubPageBlocks";
import { SELLER_PRODUCT }   from "./content/sellerProduct";
import { SELLER_SOLUTIONS } from "./content/sellerSolutions";
import { BUYER_PRODUCT }    from "./content/buyerProduct";
import { BUYER_SOLUTIONS }  from "./content/buyerSolutions";
import { COMPANY }          from "./content/company";

function NotFound({ modeOverride, tried }) {
  return (
    <SubPageLayout modeOverride={modeOverride}>
      <section className="max-w-[900px] mx-auto px-6 md:px-10 pt-24 pb-32 text-center">
        <Eyebrow>Content missing</Eyebrow>
        <h1 className="mt-6 text-[32px] md:text-[44px] font-semibold tracking-tight text-slate-900">
          This page hasn&apos;t been designed yet.
        </h1>
        <p className="mt-4 text-[14px] text-slate-500">
          Slug tried: <code className="px-1.5 py-0.5 rounded bg-slate-100">{tried}</code>
        </p>
        <Link to="/preview/nav" className="mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-lg text-white bg-slate-900 text-sm font-semibold hover:opacity-90 transition-opacity">
          Back to preview hub
        </Link>
      </section>
    </SubPageLayout>
  );
}

export function SellerProductRoute() {
  const { slug } = useParams();
  const c = SELLER_PRODUCT[slug];
  if (!c) return <NotFound modeOverride="seller" tried={`product/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="seller" />;
}

export function SellerSolutionsRoute() {
  const { slug } = useParams();
  const c = SELLER_SOLUTIONS[slug];
  if (!c) return <NotFound modeOverride="seller" tried={`solutions/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="seller" />;
}

export function SellerIndustryRoute() {
  const { slug } = useParams();
  const c = SELLER_SOLUTIONS[`industry/${slug}`];
  if (!c) return <NotFound modeOverride="seller" tried={`solutions/industry/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="seller" />;
}

export function SellerRoleRoute() {
  const { slug } = useParams();
  const c = SELLER_SOLUTIONS[`role/${slug}`];
  if (!c) return <NotFound modeOverride="seller" tried={`solutions/role/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="seller" />;
}

export function BuyerProductRoute() {
  const { slug } = useParams();
  const c = BUYER_PRODUCT[slug];
  if (!c) return <NotFound modeOverride="buyer" tried={`buyers/product/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="buyer" />;
}

export function BuyerSolutionsRoute() {
  const { slug } = useParams();
  const c = BUYER_SOLUTIONS[slug];
  if (!c) return <NotFound modeOverride="buyer" tried={`buyers/solutions/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="buyer" />;
}

export function BuyerIndustryRoute() {
  const { slug } = useParams();
  const c = BUYER_SOLUTIONS[`industry/${slug}`];
  if (!c) return <NotFound modeOverride="buyer" tried={`buyers/solutions/industry/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="buyer" />;
}

export function BuyerRoleRoute() {
  const { slug } = useParams();
  const c = BUYER_SOLUTIONS[`role/${slug}`];
  if (!c) return <NotFound modeOverride="buyer" tried={`buyers/solutions/role/${slug}`} />;
  return <SubPageRenderer content={c} modeOverride="buyer" />;
}

export function CompanyRoute() {
  const { slug } = useParams();
  const c = COMPANY[slug];
  if (!c) return <NotFound tried={`company/${slug}`} />;
  return <SubPageRenderer content={c} />;
}
